<template>
    <div v-if="options.length">
        <p class="text-xs sm:text-sm font-semibold text-brand-2-950 mb-3 sm:mb-5">
            Features
        </p>

        <ul
            class="grid grid-cols-2 sm:grid-cols-3 gap-1.5 sm:gap-2.5"
            :class="{ 'opacity-60 pointer-events-none': loading }"
        >
            <li
                v-for="option in options"
                :key="option.id"
            >
                <label
                    :for="`feature-${option.id}`"
                    class="flex items-center gap-2.5 text-xsss"
                >
                    <input
                        :id="`feature-${option.id}`"
                        class="checkbox self-start"
                        type="checkbox"
                        name="features[]"
                        :value="option.slug"
                        @change="selectOption(option.slug)"
                        :checked="props.selected.includes(option.slug)"
                    >
                    <span
                        class="pt-1"
                        v-html="option.name"
                    ></span>
                </label>
            </li>
        </ul>
    </div>
</template>

<script setup>
    import { ref } from 'vue';

    const emit = defineEmits(['selected']);

    const props = defineProps([
        'loading',
        'type',
        'selected',
    ]);

    const options = ref(props?.type == 'weddings' ? Filters.weddingFeatures : Filters.features);

    function selectOption(value) {
        let selected = props.selected;

        if (selected.includes(value)) {
            selected = selected.filter((item) => item !== value);
        } else {
            selected.push(value);
        }

        emit('selected', selected);
    }
</script>
